import useLscOfferingByOrgUnitIdAndReportPeriodIdDropdown from './UseLscOfferingByOrgUnitIdAndReportPeriodIdDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LscOfferingByOrgUnitIdAndReportPeriodIdDropdown = ({ label, name, value, error, message, onChange, orgUnitId, reportPeriodId }) => {
  const { lscOfferingByOrgUnitIdAndReportPeriodIdDropdownState } = useLscOfferingByOrgUnitIdAndReportPeriodIdDropdown(orgUnitId, reportPeriodId);

  return lscOfferingByOrgUnitIdAndReportPeriodIdDropdownState.message
    ? <span className={global.LoadingMsg}>{lscOfferingByOrgUnitIdAndReportPeriodIdDropdownState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={lscOfferingByOrgUnitIdAndReportPeriodIdDropdownState.options}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={lscOfferingByOrgUnitIdAndReportPeriodIdDropdownState.isArrayLoading} />
    );
};

export default LscOfferingByOrgUnitIdAndReportPeriodIdDropdown;